export default __webpack_public_path__ + "static/media/bec.ca7ed96f.jpg";